"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import KlaviyoSignup from "@/components/KlaviyoSignup";

// Newsletter sign-up in its own band above the footer (moved out of the footer, 2026-10-19).
// Hidden on /subscribe/, which already has the form as its main content.
export default function SignupBand() {
  const path = usePathname();
  const ref = useRef(null);
  // The leaf photo (full quality, ~90 KB) only loads when the band is about to scroll into view.
  const [near, setNear] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || near) return;
    if (!("IntersectionObserver" in window)) { setNear(true); return; }
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { setNear(true); io.disconnect(); } }, { rootMargin: "600px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [near, path]);
  if (path?.startsWith("/subscribe")) return null;
  return (
    <section ref={ref} className={`signup-band ${near ? "signup-band--bg" : ""}`} aria-labelledby="signup-band-title">
      <div className="wrap signup-band__inner">
        <span className="kicker">Join the list</span>
        <h2 id="signup-band-title" className="display-lg">
          Get on the <span className="script">wild</span> list
        </h2>
        <p className="signup-band__lede">
          New menus, Christmas and Valentine&rsquo;s first, and the odd offer worth opening.
        </p>
        <KlaviyoSignup source="Sign-up band" />
      </div>
    </section>
  );
}
